var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var colors = require("./../../../colors/colors.js");

/**
 * Created with JetBrains RubyMine.
 * User: kbruneel
 * Date: 6/27/13
 * Time: 2:08 PM
 */

var ArcFocalHandleView = function (gui, arcHandleModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.arcHandleModel = arcHandleModel;
    console.assert(this.arcHandleModel);
    this.segmentModel = this.arcHandleModel.segmentModel;
    this.pointHandleModel = this.arcHandleModel.pointHandleModel;
    this.pathInteractionModel = this.arcHandleModel.pathInteractionModel;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.interaction, layers.interactionControl], arcHandleModel);

    this.svgGroup = this.getGroupInfo(layers.interaction).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.interactionControl).svgGroup;

    this.cameraModel.viewS.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.arcHandleModel.coord.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.segmentModel.isCircular.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.segmentModel.infocus.onChange(self, function(){
        if (self.arcHandleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    },10);
    this.arcHandleModel.onDie({}, function(o){
        self.removeSvg();
        self.cameraModel.viewS.removeHandlers(self);
        self.arcHandleModel.coord.removeHandlers(self);
        self.segmentModel.isCircular.removeHandlers(self);
        self.segmentModel.infocus.removeHandlers(self);
    },101);

    this.drawIfNeeded();
};

lib_core.mixin(ArcFocalHandleView, editor_2d.DrawingElement);

module.exports = ArcFocalHandleView;


ArcFocalHandleView.prototype.drawIfNeeded = function () {
    if (this.arcHandleModel.isAlive()
        && this.segmentModel.infocus()
        && !this.segmentModel.isCircular()
    ) {
        this.draw();
    } else {
        this.emptySvgGroups();
    }
};

ArcFocalHandleView.prototype.draw = function () {
    var self = this;

    $(this.svgGroup).empty();
    $(this.controlGroup).empty();

    var c = self.arcHandleModel.coord();

    var size = 10 / this.cameraModel.viewS();
    var stroke = 1 / this.cameraModel.viewS();

    // draw the F rect
    this.gui.svg.rect(this.svgGroup,c.x-size/2,c.y-size/2,size,size,{
        'fill' : this.selected ? colors.handleFillSelected : colors.handleFill,
        'fillOpacity' : 0.5,
        'stroke' : colors.arcFHandleStroke,
        'strokeWidth' : stroke
    });

    var handle = this.gui.svg.rect(this.controlGroup, c.x - size / 2, c.y - size / 2, size, size);

    $(handle).mousedown(function (event) {
        return self.onMouseDown(event);
    });

    //hacky fit this in here
    //draw the line on which the focal points move
    if(this.arcHandleModel.type() == "F") { //so that we draw it only once
        var curvePoints = self.segmentModel.validFocalPointsCurve();

        if(curvePoints != null) {
            var theme = this.arcHandleModel.parent().parent().origin.theme;
            var curveColor = colors.arcConstrainedMoveLine[theme];

            // display the implied curves of valid F anf F' points
            for(var curveNum = 0; curveNum < curvePoints.length; curveNum++) {
                var curve_string = curvePoints[curveNum].map(function(coord) {return [coord.x, coord.y];});
                this.gui.svg.polyline(this.svgGroup,
                    curve_string, {
                    'opacity': 0.3,
                    'fill': 'none',
                    stroke: curveColor,
                    'strokeWidth' : stroke
                });
            }
        }
    }
};

ArcFocalHandleView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.arcHandleModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) )
        .data( 'notFocusable', true );

    return this.gui.stateMachine.handle(cEvent);
};
